import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound404.css';

const NotFound404 = () => {
  return (
    <div className="not-found d-flex justify-content-center align-items-center text-center">
      <div className="content">
        <h1 className="display-1 fw-bold">404</h1>
        <h2 className="mb-3">Oups ! Nous avons pris un mauvais virage.</h2>
        <p className="mb-4">La page que vous cherchez n'existe pas ou a été déplacée.</p>
        <Link to="/" className="btn btn-gold px-4 py-2">Retour à l'accueil</Link>
      </div>
    </div>
  );
};

export default NotFound404;
